module.exports = __webpack_public_path__ + "img/la_hi.a6e56077.jpg";